/** Compatibility shim. Keep this JS re-export while legacy imports still reference `vue-i18n.js`. */
import i18n from './vue-i18n.ts';

export default i18n;
